import { useState } from 'react';

/**
 * Hook para manejar la navegación entre pasos del wizard
 */
export const useFacturaSteps = (totalPasos: number = 3) => {
  const [pasoActual, setPasoActual] = useState(1);

  const siguiente = () => {
    if (pasoActual < totalPasos) {
      setPasoActual(pasoActual + 1);
    }
  };

  const anterior = () => {
    if (pasoActual > 1) {
      setPasoActual(pasoActual - 1);
    }
  };

  const irAPaso = (paso: number) => {
    if (paso >= 1 && paso <= totalPasos) {
      setPasoActual(paso);
    }
  };

  const resetear = () => {
    setPasoActual(1);
  };

  const esPrimerPaso = pasoActual === 1;
  const esUltimoPaso = pasoActual === totalPasos;

  return {
    pasoActual,
    totalPasos,
    siguiente,
    anterior,
    irAPaso,
    resetear,
    esPrimerPaso,
    esUltimoPaso,
  };
};
